import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { FieldOption, LogicApplication } from '@/types/logic';
import ajax from '@/utils/ajax';

const basePath = '/api/dugout/logic_applications';

export const logicApplicationRepository = {
  /**
   * Get-or-creates the LogicApplication for a registered application key (mirrors
   * `BaseLogicApplicationService._application()` server-side) -- so callers only
   * ever need to know the key, never the row's id or its subject content type.
   */
  async getByKey({ host, key }: { host: string; key: string }): Promise<LogicApplication> {
    const response = await ajax.get({ url: `${host}${basePath}/by_key/`, params: { key } });
    return response.data as LogicApplication;
  },

  async getFieldOptions({
    host,
    applicationId
  }: {
    host: string;
    applicationId: string;
  }): Promise<FieldOption[]> {
    const response = await ajax.get({
      url: `${host}${basePath}/${applicationId}/options/`
    });
    return response.data as FieldOption[];
  }
};

const LogicApplicationRepository = () => {
  const { host } = useContext(AppContext);

  return {
    getByKey: (key: string) => logicApplicationRepository.getByKey({ host, key }),
    getFieldOptions: (applicationId: string) =>
      logicApplicationRepository.getFieldOptions({ host, applicationId })
  };
};

export default LogicApplicationRepository;
